const JMACompetitor = ["ERA", "Huttons", "PropNex"];

export function getAgentType(name: string): string {
  if (
    JMACompetitor.some((agency) =>
      name.toLowerCase().includes(agency.toLowerCase())
    )
  ) {
    return "JMA - Competitor";
  }
  return "ECB - Non - Competitor";
}
